import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { toast } from "react-toastify";

import Modal from "./../../elements/Modal";
import { Button } from "./../../elements/Button";

import commoncss from "./../../css/common.module.css";
import libcss from "../../css/library.module.css";
import buttoncss from "./../../css/button.module.css";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import adminPortalCss from "../../css/adminportal.module.css";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import {
  getAllLinkedFSApiHandler,
  overrideFSApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

const OverrideFSModal = ({ groupingTemplateID, setShowOverrideModal }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [linkedFSList, setLinkedFSList] = useState([]);

  useEffect(() => {
    getAllLinkedFSApiHandler(groupingTemplateID)
      .then((response) => {
        const linkedFSArray = response?.data?.linkedFSArray ?? [];
        console.log("linkedFSArray", linkedFSArray);

        setLinkedFSList(linkedFSArray);
      })
      .catch((error) => {
        swal(
          "Error",
          error.response.data.error || "Error: Get Linked Register API Failed!",
          "error"
        );
      });
  }, []);

  useEffect(() => {
    console.log("selectedItem", selectedItem);
  }, [selectedItem]);
  const data = [...Array(12)].map((_, i) => ({
    id: i + 1,
    label: `FS ${i + 1}`,
  }));

  const [checkedFS, setCheckedFS] = useState([]);

  const handleChange = (id, isChecked) => {
    setCheckedFS((prev) =>
      isChecked ? [...prev, id] : prev.filter((x) => x !== id)
    );
  };

  const handleOverride = () => {
    if (selectedItem === "dont_override") {
      return setShowOverrideModal(false);
    } else {
      const allFS = linkedFSList.map((item) => item._id);
      const payload = {
        projectIDList: selectedItem === "override_all" ? allFS : checkedFS,
      };

      console.log("payload", payload);

      overrideFSApiHandler({ groupingTemplateID: groupingTemplateID }, payload)
        .then((response) => {
          if (response?.data?.success === true) {
            swal("Override successful", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to Override",
              "error"
            );
          }
        })
        .catch((error) => {
          swal(
            "Error",
            error?.response?.data?.error || "Unable to Override",
            "error"
          );
        });
    }
  };
  return (
    <Modal
      width="35%"
      // minHeight="500px"
      title="Override"
      bodycss={commoncss.unsetPadding}
      headerActions={<CloseIcon onClick={() => setShowOverrideModal(false)} />}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            label="Cancel"
            onClick={() => setShowOverrideModal(false)}
          />
          &ensp;
          <Button
            btnColor={buttoncss.primary}
            label="Continue"
            onClick={handleOverride}
          />
        </>
      }
    >
      <div style={{ padding: "10px 50px" }}>
        <div className={libcss.overrideNote}>
          This Template is linked to{" "}
          <span className={`${commoncss.fw600} ${commoncss.fs16}`}>
            {linkedFSList.length} Financial statements
          </span>
          .<br /> How would you like to override the changes you have made?
        </div>
        <div
          className={adminPortalCss.radioButtonSection}
          style={{ justifyContent: "center", marginTop: "25px", marginBottom: "15px" }}
        >
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="override"
            value={selectedItem}
            onChange={(e) => setSelectedItem(e.target.value)}
            className={adminPortalCss.radioSection}
            sx={{ gap: "25px" }}
          >
            <FormControlLabel
              value="override_all"
              className={adminPortalCss.radioLabel}
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Override to all"
              sx={{
                marginRight: 0,
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
            <FormControlLabel
              className={adminPortalCss.radioLabel}
              value="override_selected"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Override to selected"
              sx={{
                marginRight: 0,
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
            <FormControlLabel
              className={adminPortalCss.radioLabel}
              value="dont_override"
              control={
                <Radio
                  sx={{
                    "& .MuiSvgIcon-root": { fontSize: 18 },
                    color: "#D6D6D6",
                    "&.Mui-checked": { color: "#3AB67D" },
                  }}
                />
              }
              label="Don't Override"
              sx={{
                marginRight: 0,
                "& .MuiFormControlLabel-label": {
                  fontWeight: 500,
                  textTransform: "none",
                  color: "#111111",
                  fontSize: "15px",
                },
              }}
            />
          </RadioGroup>
        </div>
        {selectedItem === "override_selected" && (
          <div className={`${libcss.selectFsDiv} my-3`}>
            <span className={`${commoncss.primaryLable}`}>
              Select FS to override
            </span>
            <div className={`${libcss.fsGrid} mt-2`}>
              {linkedFSList.length > 0 &&
                linkedFSList.map((item) => (
                  <div key={item.id} className={libcss.fsItem}>
                    <input
                      type="checkbox"
                      checked={checkedFS.includes(item._id)}
                      onChange={(e) => handleChange(item._id, e.target.checked)}
                    />
                    <span>{item.project_name}</span>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default OverrideFSModal;
